import React, { useEffect, useRef, useState } from "react";
import "./../styles/Monitor.style.css";
import Environment from "./Environment";
import HeadBar from "./HeadBar";
import loader from "../assets/loader.gif";
import { EnvironmentsData, ResourcesData } from "../models/ResourcesTypes";

const DEFAULT_GRID_VIEW = "6";

interface MonitorProps {
  environments: EnvironmentsData;
  resources: ResourcesData;
  filter: string;
  setFilter: (f: string) => void;
  timeframe: string;
  setTimeframe: (t: string) => void;
  setReload: (v: boolean) => void;
  statusType: string;
  resourceType: string;
  anyFilter: boolean;
  zeroRun: boolean;
  logs: string[];
  healthStatus: "green" | "yellow" | "red" | null;
  autoRefresh: boolean;
  setAutoRefresh: (v: boolean) => void;
  autoRefreshInterval: number;
  setAutoRefreshInterval: (v: number) => void;
  onLogout?: () => void;
}

const Monitor: React.FC<MonitorProps> = (props) => {
  const [gridView, setGridView] = useState(DEFAULT_GRID_VIEW);

  const {
    environments,
    resources,
    filter,
    setFilter,
    timeframe,
    setTimeframe,
    setReload,
    statusType,
    resourceType,
    anyFilter,
    zeroRun,
    logs,
    healthStatus,
    autoRefresh,
    setAutoRefresh,
    autoRefreshInterval,
    setAutoRefreshInterval,
    onLogout,
  } = props;

  const loggerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (loggerRef.current) {
      loggerRef.current.scrollTop = loggerRef.current.scrollHeight;
    }
  }, [logs]);

  return (
    <div className="monitor-container">
      <HeadBar
        environments={environments}
        datetime={resources.datetime as string}
        filter={filter}
        setFilter={setFilter}
        timeframe={timeframe}
        setTimeframe={setTimeframe}
        setReload={setReload}
        gridView={gridView}
        setGridView={setGridView}
        statusType={statusType}
        resourceType={resourceType}
        anyFilter={anyFilter}
        zeroRun={zeroRun}
        healthStatus={healthStatus}
        autoRefresh={autoRefresh}
        setAutoRefresh={setAutoRefresh}
        autoRefreshInterval={autoRefreshInterval}
        setAutoRefreshInterval={setAutoRefreshInterval}
        onLogout={onLogout}
      ></HeadBar>
      {Object.keys(resources).length === 0 && (
        <div className="split">
          <img
            className="loader"
            src={loader}
            alt="Rubik's cube solving..."
          ></img>
          <div className="logger" ref={loggerRef}>
            {logs.map((log: string) => (
              <span key={log}>{log}</span>
            ))}
          </div>
        </div>
      )}
      {Object.keys(resources).includes("error") && (
        <div className="split">
          <div className="error">
            <p>🤖 Rubik&apos;s cube is not solving...</p>
            <p>
              🔑 Your <strong>credentials might be expired</strong>. Time for an
              upgrade?
            </p>
          </div>
          <div className="logger" ref={loggerRef}>
            {logs.map((log: string) => (
              <span key={log}>{log}</span>
            ))}
          </div>
        </div>
      )}
      {environments &&
        Object.keys(resources).length !== 0 &&
        !Object.keys(resources).includes("error") &&
        Object.keys(environments).map((env: string, index: number) => (
          <Environment
            key={index}
            title={env}
            resources={resources}
            filter={filter}
            gridView={gridView}
            statusType={statusType}
            resourceType={resourceType}
            anyFilter={anyFilter}
            zeroRun={zeroRun}
          ></Environment>
        ))}
    </div>
  );
};

export default Monitor;
